export default __webpack_public_path__ + "static/media/Jets.3c4edb14.png";